// extracted by mini-css-extract-plugin
export default {"indicator":"color-select_indicator__INyTl"};